// M140 — Feature-gate rondom legacy routes. Leest `activeOrg.feature_flags`
// uit de auth-context; toont een B1-NL "uit"-pagina als de flag `false` is.
// Dit voorkomt dat oude execution-UIs (publish queue, social suite, …)
// bereikbaar blijven via directe URL-navigatie ondanks de verborgen nav.
import { Link } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { AppLayout } from "@/components/AppLayout";
import { PowerOff, ArrowLeft, Loader2 } from "lucide-react";

export function FeatureGate({ flag, children }) {
  const { activeOrg, loading } = useAuth();
  if (loading) {
    return (
      <AppLayout>
        <div className="text-text-muted text-sm flex items-center gap-2 mt-8">
          <Loader2 className="w-3.5 h-3.5 animate-spin" /> Even geduld…
        </div>
      </AppLayout>
    );
  }
  const flags = activeOrg?.feature_flags || {};
  if (flags[flag] === true) return children;
  return <DisabledFeaturePage flag={flag} />;
}

function DisabledFeaturePage({ flag }) {
  return (
    <AppLayout>
      <div
        data-testid="disabled-feature-page"
        data-flag={flag}
        className="max-w-xl mx-auto mt-16 rounded-card border border-border-hairline bg-bg-panel p-8 text-center"
      >
        <PowerOff className="w-8 h-8 text-text-muted mx-auto mb-4" />
        <h1
          data-testid="disabled-feature-title"
          className="text-xl font-display text-text-primary mb-3"
        >
          Deze functie staat uit
        </h1>
        <p className="text-sm text-text-muted mb-5 leading-relaxed">
          Deze functie is voor jouw bedrijf niet actief. Vraag je JustEasySEO-adviseur
          als je 'm nodig hebt.
        </p>
        <Link
          to="/"
          data-testid="disabled-feature-back"
          className="inline-flex items-center gap-2 text-[11px] px-3 py-1.5 rounded border border-accent-teal/40 text-accent-teal hover:bg-accent-teal/10"
        >
          <ArrowLeft className="w-3 h-3" /> Terug naar dashboard
        </Link>
      </div>
    </AppLayout>
  );
}
